module.exports = __webpack_public_path__ + "img/339.bfcc4a71.png";